<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer
    v-model="isSidebarActiveLocal"
  >

    <add-new-brand
      :isPromptActive="IsPromptActive.newBrand"
      :AllBrands="AllBrands"
      @addedNewBrand="addedNewBrand($event)"
      @closePrompt="IsPromptActive.newCategory = false"
    />

   <add-new-category
      :isPromptActive="IsPromptActive.newCategory"
      :AllCategories="AllCategories"
      @closePrompt="IsPromptActive.newCategory = false; isSidebarActiveLocal = true;"
    />

    <add-new-supplier
      :isPromptActive="IsPromptActive.newSupplier"
      :AllSuppliers="AllSuppliers"
      @addedNewSupplier="addedNewSupplier($event)"
    />


    <div class="mt-6 flex items-center justify-between px-6">
      <div class="flex">
        <h4 :class="fullName != '' ? 'sidebarHeaderItem' : ''" v-if="NewProduct.detailsID == 0 && !editingProduct">NUEVO PRODUCTO</h4>
        <h4 :class="fullName != '' ? 'sidebarHeaderItem' : ''" v-if="NewProduct.detailsID != 0 && !editingProduct">NUEVA VARIEDAD</h4>
        <h4 :class="fullName != '' ? 'sidebarHeaderItem' : ''" v-if="editingProduct">MODIFICAR PRODUCTO</h4>
        <div class="sidebarHeaderItemSeparation"></div>
        <vs-checkbox :class="fullName != '' ? 'sidebarHeaderItem' : ''" v-model="doNotClose">No cerrar</vs-checkbox>
      </div>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <vs-row v-if="fullName != ''" class="p-6 pb-0 pt-4">
      <vs-col vs-type="flex" vs-w="12" class="noPaddingX">
        <h2>{{ fullName }}</h2>
      </vs-col>
    </vs-row>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-0 pb-6" :settings="scrollbarSettings">

      <div class="p-6 pt-0">

        <!-- <vs-row>
          <vs-col vs-type="flex" vs-w="12" class="noPaddingX" v-if="NewProduct.detailsID != 0">
            <h5 style="display: block">Otras variantes:</h5>
          </vs-col>
          <vs-col vs-type="flex" vs-w="12" class="noPaddingX" v-if="NewProduct.detailsID != 0" style="margin-top: 10px; margin-bottom: 15px;">
            <ul>
              <li v-for="Sibling in Siblings" :key="'sibling-'+ Sibling.id">
                {{ '- '+ Sibling.fullName }}
              </li>
            </ul>
          </vs-col>
        </vs-row> -->

        <vs-row>
          <!-- Name -->
          <vs-col vs-type="flex" vs-w="12" class="noPaddingX">
            <vs-input v-model="NewProduct.name" label="Nombre" class="mt-5 w-full" />
          </vs-col>
        </vs-row>

        <vs-row>
          <!-- VariantName -->
          <vs-col vs-w="6" class="colLeft">
            <label class="labelTitle mt-2 w-full">Variante</label>
            <vs-input v-model="NewProduct.variantName" class="w-full" />
          </vs-col>
          <!-- Brand -->
          <vs-col vs-w="6" class="colRight">
            <label class="labelTitle mt-2 w-full">Marca</label>
            <v-select v-model="SelectedBrand" :options="AllBrands"></v-select>
          </vs-col>
        </vs-row>

        <vs-row>
          <!-- Category -->
          <vs-col vs-w="8" class="colLeft">
            <label class="labelTitle mt-2 w-full">Categorías</label>
            <v-select multiple v-model="SelectedCategories" :options="AllCategories"></v-select>
          </vs-col>
          <!-- BarsCode -->
          <vs-col vs-w="4" class="colRight">
            <label class="labelTitle mt-2 w-full">Código de barras</label>
            <vs-input v-model="NewProduct.barsCode" class="w-full" />
          </vs-col>
        </vs-row>

        <!-- SUPPLIERS -->
        <!-- SupplierID -->
        <!-- <vs-row> -->
          <!-- <vs-col vs-w="6" class="colLeft">
            <label class="labelTitle mt-2 w-full">Proveedor</label>
            <v-select v-model="SelectedSuppliers[0]" :options="AllSuppliers"></v-select>
          </vs-col> -->
          <!-- IVA -->
          <!-- <vs-col vs-w="6" class="noPaddingX">
            <vs-input-number label="IVA" v-model="NewProduct.iva" class="numberInputRight" style="padding: 8px; margin-top: 23px;" @focus="$event.target.select()"/>
          </vs-col> -->
          <!-- Buy price -->
          <!-- <vs-col vs-w="6" class="noPaddingX">
            <vs-input-number label="$ compra sin IVA" v-model="NewProduct.noIvaPrice" class="numberInputLeft" style="padding: 8px;" @focus="$event.target.select()"/>
          </vs-col>
          <vs-col vs-w="6" class="noPaddingX">
            <vs-input-number label="$ compra con IVA" v-model="SelectedSuppliersPrices[0]" class="numberInputRight" style="padding: 8px;" @focus="$event.target.select()"/>
          </vs-col> -->
        <!-- </vs-row> -->

        <!-- Description -->
        <!-- <div>
          <label class="labelTitle mt-2 w-full">Descripción</label>
          <vs-textarea class="textarea" v-model="NewProduct.description" />
        </div> -->

        <!-- IMAGES -->
        <vs-row>
          <!-- IMG WEBP-->
          <vs-col vs-type="flex" vs-w="6" class="colLeft">
            <div class="allImgContainer">
              <h5 class="text-center mt-2 mb-2">.webp</h5>
              <!-- Button -->
              <div class="loadImgBTN" @click="$refs.fileInputWEBP.click()" v-if="photoDataWEBP.length == 0">Imagen</div>
              <!-- preview -->
              <div class="imgPreview" v-if="photoDataWEBP.length > 0">
                <img :src="photoDataWEBP" alt="Imagen">
              </div>
              <!-- Close button -->
              <feather-icon icon="XIcon" class="deleteImgBTN"  @click="photoDataWEBP = ''" v-if="photoDataWEBP != ''"></feather-icon>
              <!-- Real input -->
              <input type="file" @change="loadPhoto('webp', $event)" ref="fileInputWEBP" accept="image/*" v-show="false">
            </div>
          </vs-col>

          <!-- IMG JPG -->
          <vs-col vs-type="flex" vs-w="6" class="colLeft">
            <div class="allImgContainer">
              <h5 class="text-center mt-2 mb-2">.jpg</h5>
              <!-- Button -->
              <div class="loadImgBTN" @click="$refs.fileInputJPG.click()" v-if="photoDataJPG.length == 0">Imagen</div>
              <!-- preview -->
              <div class="imgPreview" v-if="photoDataJPG.length > 0">
                <img :src="photoDataJPG" alt="Imagen">
              </div>
              <!-- Close button -->
              <feather-icon icon="XIcon" class="deleteImgBTN"  @click="photoDataJPG = ''" v-if="photoDataJPG != ''"></feather-icon>
              <!-- Real input -->
              <input type="file" @change="loadPhoto('jpg', $event)" ref="fileInputJPG" accept="image/*" v-show="false">
            </div>
          </vs-col>

          <vs-col vs-w="6" class="noPaddingX">
            <!-- <vs-row> -->
              <!-- Price multiplier -->
              <!-- <vs-col vs-w="3" class="colLeft" style="position: relative;">
                <span class="priceMultiplierX">x</span>
                <input type="number" class="priceMultiplier" v-model="priceMultiplier">
              </vs-col> -->
              <!-- Price -->
              <!-- <vs-col vs-w="9" class="colRight"> -->
                <vs-input-number label="Precio" name="price" v-model="NewProduct.price" class="numberInputList numberInputRight" @focus="$event.target.select()"/>
              <!-- </vs-col> -->
            <!-- </vs-row> -->
            <!-- Offert -->
            <vs-input-number label="Oferta" name="offert" v-model="NewProduct.offert" class="numberInputList numberInputRight" @focus="$event.target.select()"/>
            <!-- stock -->
            <vs-input-number label="Stock" name="stock" v-model="NewProduct.stock" class="numberInputList numberInputRight" @focus="$event.target.select()"/>
            <!-- stockAlert -->
            <vs-input-number label="Alerta" name="stockAlert" v-model="NewProduct.stockAlert" class="numberInputList numberInputRight" @focus="$event.target.select()"/>
          </vs-col>
        </vs-row>




        <!-- EXTRAS -->
        <vs-collapse :type="'border'" class="mt-5" style="padding-bottom: 10px;">
          <vs-collapse-item>
            <div slot="header">Extras</div>
            <vs-row>
              <!-- isActive -->
              <vs-col vs-type="flex" vs-w="6">
                <vs-checkbox v-model="!NewProduct.isActive" class="mt-2">No publicado</vs-checkbox>
              </vs-col>
              <!-- OnlySuppliers -->
              <vs-col vs-type="flex" vs-w="6">
                <vs-checkbox v-model="NewProduct.onlySuppliers" class="mt-2">Solo proveedores</vs-checkbox>
              </vs-col>
            </vs-row>

            <vs-row>
              <vs-col vs-type="flex" vs-w="6">
                <vs-checkbox v-model="differentPrice" class="mt-2">Precio distinto</vs-checkbox>
              </vs-col>
              <vs-col vs-type="flex" vs-w="6">
                <vs-checkbox v-model="hasParent" class="mt-2">Tiene padre</vs-checkbox>
              </vs-col>
            </vs-row>

            <!-- DIFFERENT PRICE -->
            <vs-row v-if="differentPrice" vs-type="flex" class="mt-2">
              <!-- variantPrice -->
              <vs-col vs-type="flex" vs-w="6" class="noPaddingX">
                <vs-input-number label="Precio variante" name="variantPrice" v-model="NewProduct.variantPrice" class="w-full" />
              </vs-col>
              <!-- variantOffert -->
              <vs-col vs-type="flex" vs-w="6" class="noPaddingX">
                <vs-input-number label="Oferta variante" name="variantOffert" v-model="NewProduct.variantOffert" class="w-full" />
              </vs-col>
            </vs-row>

            <!-- HAS PARENT -->
            <vs-row v-if="hasParent" class="mt-2">
              <!-- productParentID -->
              <vs-col vs-type="flex" vs-w="6" class="noPaddingX">
                <v-select v-model="NewProduct.productParentID" :options="allProducts"></v-select>
              </vs-col>
                <!-- productParentMultiplier -->
              <vs-col vs-type="flex" vs-w="6" class="noPaddingX" style="margin-top: 22px;">
                <vs-input-number label="Multiplicador padre" name="productParentMultiplier" v-model="NewProduct.productParentMultiplier" class="w-full" />
              </vs-col>
            </vs-row>

            <!-- extraDescription -->
            <div>
              <label class="labelTitle mt-2">Descripción extra</label>
              <vs-textarea v-model="NewProduct.extraDescription" class="mt-2" />
            </div>

          </vs-collapse-item>
        </vs-collapse>

        <p class="helpInfo">* En el nombre se pueden usar los valores { variante } { marca } *</p>

      </div>

    </VuePerfectScrollbar>

    <!-- BUTTONS -->
    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-row>
        <!-- Crear -->
        <vs-col vs-type="flex" vs-w="8">
          <vs-button v-if="!editingProduct && NewProduct.detailsID == 0" class="w-full" @click="addProductDetails()">Crear producto</vs-button>
          <vs-button v-if="!editingProduct && NewProduct.detailsID != 0" class="w-full" @click="addProduct()">Crear variedad</vs-button>
          <vs-button v-if="editingProduct" class="w-full" @click="addProduct()">Modificar producto</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-w="4">
          <vs-button type="border" class="w-full" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
        </vs-col>
      </vs-row>
    </div>
  </vs-sidebar>
</template>





<!-- - - - - - - - - - - - - - - - SCRIPT - - - - - - - - - - - - - - - -->
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import vSelect from 'vue-select';
export default {
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    addNewBrand: () => import('../addNew/AddNewBrand.vue'),
    addNewCategory: () => import('../addNew/AddNewCategory.vue'),
    addNewSupplier: () => import('../addNew/AddNewSupplier.vue'),
  },
  props: {
    isSidebarActive: { type: Boolean, required: true, },
    allProducts: { type: Array, required: true, },
  },
  data() {
    return {
      IsPromptActive: {
        newBrand: false, newCategory: false, newSupplier: false,
      },
      NewProduct: this.getNewProduct(),
      photoDataWEBP: '', // we will store base64 format of image in this string
      photoDataJPG: '', // we will store base64 format of image in this string
      priceMultiplier: 1.3,
      Siblings: [],
      // Logic
      editingProduct   : false,
      differentPrice: false,
      hasParent     : false,
      doNotClose    : false,
      photoUploaded : false,
      // Options
      AllBrands: [],
      AllCategories: [],
      AllSuppliers: [],
      // Selected
      SelectedBrand: null,
      SelectedCategories: [],
      SelectedSuppliers: [null],
      SelectedSuppliersPrices: [0],
      // loaded
      LoadedCategories: [],
      LoadedSuppliers: [],
      LoadedPrice: 0,
      LoadedOffert: 0,
      scrollbarSettings: { // perfectscrollbar settings
          // maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  created() {
    this.loadBrands();
    this.loadSuppliers();
    this.loadCategories();
    this.getProductID();
  }, // created()
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        this.$emit('modifySidebar', val);
      }
    },
    fullName: function() {
      let Info = {
        title: this.NewProduct.name,
        brand: this.SelectedBrand == null ? '' : this.SelectedBrand.label,
        variantName: this.NewProduct.variantName,
      }
      return this.getFullName(Info)
    }, // END fullName
    // SelectedSuppliersPrices[0] : {
    //   get() {
    //     return val + val * this.NewProduct.iva;
    //   },
    // }
  },
  watch: {
    'NewProduct.id': function(val) {
      console.log(val)
    },
    priceMultiplier: function() {
      this.NewProduct.price = parseFloat((this.priceMultiplier * this.SelectedSuppliersPrices[0])).toFixed(2);
    },
    SelectedSuppliersPrices: function(val) {
      val[0] = parseFloat(val[0]);
      this.NewProduct.price = parseFloat((this.priceMultiplier * val[0])).toFixed(2);
    },
    'NewProduct.iva': function(val) {
      let notIvaPrice = parseFloat(this.NewProduct.noIvaPrice);
      this.$set(this.SelectedSuppliersPrices, '0', (notIvaPrice + notIvaPrice * val / 100).toFixed(2));
    },
    'NewProduct.noIvaPrice': function(val) {
      val = parseFloat(val);
      this.$set(this.SelectedSuppliersPrices, '0', (val + val * this.NewProduct.iva / 100).toFixed(2));
    },
    differentPrice: function() {
      this.variantPrice = 0;
      if (!this.differentPrice) {
        this.variantPrice  = 0;
        this.variantOffert = 0;
      }
    },
    hasParent: function() {
      if (!this.hasParent) {
        this.productParentID = 0;
      }
    },
    SelectedBrand: function (Brand) {
      if (Brand == null) return;
      if (Brand.id == -1) {
        this.isSidebarActiveLocal = false;
        this.IsPromptActive.newBrand = true;
        this.SelectedBrand = null;
      } else {
        this.NewProduct.brandID = Brand.id;
      }
    },
    SelectedCategories: function (Categories) {
      let amount = Categories.length;
      if (!amount) return;
      if (Categories[amount-1].id == '-1') {
        this.isSidebarActiveLocal = false;
        this.IsPromptActive.newCategory = true;
        this.SelectedCategories.pop();
      }
    },
    SelectedSuppliers: function (Suppliers) {
      let amount = Suppliers.length;
      if (!amount) return;
      if (Suppliers[0] == null) return;
      if (Suppliers[amount-1].id == '-1') {
        this.isSidebarActiveLocal = false;
        this.IsPromptActive.newSupplier = true;
        this.SelectedSuppliers[amount-1] = null;
      }
    },
  }, // WATCH
  methods: {


    // addedNewBrand
    // addedNewSupplier
    // addProduct
    // addProductActivityHistory
    // 0Details
    // addProductDetailsUCategories
    // addProductDetailsUCategoriesHistory
    // addProductPriceHistory
    // addSupplierUProduct
    // addSupplierUProductHistory
    // cleanData
    // deleteProductDetailsUCategories
    // getFullName
    // getNewProduct
    // imgDelete
    // imgError
    // imgUpload
    // loadBrands
    // loadCategories
    // loadPhoto
    // loadProductCategories
    // loadProductDetails
    // loadProductSupplier
    // loadSuppliers
    // modifyProduct
    // modifySupplierUProduct
    // startEditProduct
    // startNewProduct
    // updateCategories
    // updatePrice
    // updateSuppliers


    addedNewBrand(newBrand) {
      this.IsPromptActive.newBrand = false;
      this.isSidebarActiveLocal = true;
      for (let i in this.AllBrands) {
        if (this.AllBrands[i].id == newBrand.id) {
          this.SelectedBrand = this.AllBrands[i];
        }
      }
    }, // addedNewBrand

    addedNewSupplier(newSupplier) {
      this.IsPromptActive.newSupplier = false;
      this.isSidebarActiveLocal = true;
      for (let i in this.AllSuppliers) {
        if (this.AllSuppliers[i].id == newSupplier.id) {
          this.SelectedSuppliers.push(this.AllSuppliers[i]);
        }
      }
    }, // addedNewSupplier

    addProduct() {
      const vm = this;
      console.log(vm.NewProduct);
      let Params = this.NewProduct;
      var newProd = Params;
      Params.fullName = this.fullName;
      let action = this.editingProduct ? 'modifyProduct' : 'createProduct';
      console.log(Params);
      this.conectToDB({
        file: 'NewProduct', action: action, params: Params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          let notifyMsg = '';
          console.log(vm.NewProduct);
          if (!vm.editingProduct) {
            newProd.isNew = true;
            vm.allProducts.unshift(newProd);
            notifyMsg = `Producto <b>${newProd.fullName}</b> creado correctamente`;
          } else {
            newProd.isModified = true;
            // replace product
            for (let i in vm.allProducts) {
              if (vm.allProducts[i].id == newProd.id) {
                vm.allProducts[i] = newProd;
              }
            }
            notifyMsg = `Producto <b>${newProd.fullName}</b> modificado correctamente`;
          }
          // actions shared by add and modify
          console.log(notifyMsg);
          vm.myNotify('success', 'Éxito', notifyMsg);
          // isActive history
          let Params = {
            productID: vm.NewProduct.id,
            isActive: vm.NewProduct.isActive,
          }
          console.log(Params);
          vm.addProductActivityHistory(Params);
          vm.updateCategories();
          vm.updatePrice();
          vm.updateSuppliers();
          // Close
          if (!vm.doNotClose) { vm.isSidebarActiveLocal = false;
          } else { vm.startNewProduct(); }
        },
      });
    }, // addProduct

    addProductActivityHistory(params) {
      this.conectToDB({
        file: 'NewProduct', action: 'createProductActivityHistory',
        params: params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log('Actividad agregada a la historia');
        },
      });
    }, // addProductActivityHistory

    addProductDetailsUCategories(params) {
      const vm = this;
      this.conectToDB({
        file: 'NewProduct', action: 'createProductDetailsUCategories',
        params: params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log('Categoría agregada al producto');
          vm.addProductDetailsUCategoriesHistory(params);
        },
      });
    }, // addProductDetailsUCategories

    addProductDetailsUCategoriesHistory(params) {
      this.conectToDB({
        file: 'NewProduct', action: 'createProductDetailsUCategoriesHistory',
        params: params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log('Categoría agregada al producto history');
        },
      });
    }, // addProductDetailsUCategoriesHistory

    addProductDetails() {
      const vm = this;
      let action = this.editingProduct ? 'modifyProductDetails' : 'createProductDetails';
      this.conectToDB({
        file: 'NewProduct', action: action,
        params: this.NewProduct,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log('Detalles producto creado');
          vm.NewProduct.detailsID = res.data.data;
          vm.addProduct();
        },
      });
    }, // END addProductDetails

    addProductPriceHistory(params) {
      this.conectToDB({
        file: 'NewProduct', action: 'createProductPriceHistory',
        params: params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log('Precio agregado a la historia');
        },
      });
    }, // addProductPriceHistory

    addSupplierUProduct(params) {
      const vm = this;
      this.conectToDB({
        file: 'NewProduct', action: 'createSupplierUProduct',
        params: params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log('Producto agregado al proveedor');
          vm.addSupplierUProductHistory(params);
        },
      });
    }, // addSupplierUProduct

    addSupplierUProductHistory(params) {
      this.conectToDB({
        file: 'NewProduct', action: 'createSupplierUProductHistory',
        params: params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log('Producto agregado al proveedor (historia)');
        },
      });
    }, // addSupplierUProductHistory

    cleanData() {
      console.log('LIMPIO');
      this.NewProduct = this.getNewProduct();
      this.photoDataWEBP = '';
      this.photoDataJPG = '';
      this.priceMultiplier = 1.3;
      this.editingProduct = false;
      this.differentPrice = false;
      this.hasParent = false;
      this.photoUploaded = false;
      this.Siblings = [];
      // Selected
      this.SelectedBrand = null;
      this.SelectedCategories = [];
      this.SelectedSuppliers = [];
      this.SelectedSuppliersPrices = [0];
      // loaded
      this.LoadedCategories = [];
      this.LoadedSuppliers = [];
      this.getProductID();
    }, // cleanData

    deleteProductDetailsUCategories(params) {
      const vm = this;
      this.conectToDB({
        file: 'NewProduct', action: 'deleteProductDetailsUCategories',
        params: params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log('Categoría modificada para el producto');
          params.isActive = 0;
          vm.addProductDetailsUCategoriesHistory(params);
        },
      });
    }, // deleteProductDetailsUCategories

    getFullName(Info) {
      let title = Info.title;
      let start = title.indexOf("{");
      let end = title.indexOf("}");
      while (start != -1 && end != -1) {
        let variableName = title.substring(start+1, end).trim().toLowerCase();
        let variable = '';
        switch (variableName) {
          case 'marca':
          variable = Info.brand;
          break;
          case 'variante':
          variable = Info.variantName;
          break;
          default: variable = '#ERROR#';
        }
        title = title.substring(0, start) + variable + title.substring(end+1, title.length);
        start = title.indexOf("{");
        end = title.indexOf("}");
      }
      return title;
    }, // getFullName

    getNewProduct() {
      return {
        productID: 0,
        // Product details
        name: '',
        brandID: 0,
        price: 0,
        offert: 0,
        description: '',
        // Product
        detailsID: 0,
        variantName: '',
        stock: 0,
        stockAlert: 0,
        variantPrice: 0,
        variantOffert: 0,
        productParentID: 0,
        productParentMultiplier: 0,
        extraDescription: '',
        imagesAmount: 1,
        barsCode: '',
        isActive: true,
        onlySuppliers: false,
        iva: 21.0,
        noIvaPrice: 0.0,
      };
    }, // getNewProduct

    getProductID() {
      const vm = this;
      this.conectToDB({
        file: 'Products',
        action: 'getProduct',
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.NewProduct.id = res.data.data.length;
        },
      });
    }, // END getProductID

    imgDelete() {
      this.photoUploaded = false;
      console.log(this.photoUploaded);
    },

    imgError(event) {
      this.photoUploaded = true;
      console.log(event);
      console.log(this.photoUploaded);
    },

    imgUpload() {
      this.photoUploaded = true;
      console.log(this.photoUploaded);
    },

    loadBrands() {
      const vm = this;
      this.conectToDB({
        file: 'Products', action: 'getBrand', params: { isActive: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.AllBrands = vm.renameToLabel(res.data.data);
          vm.AllBrands.unshift({ id: -1, label: '* Crear nueva marca *'});
        },
      });
    }, // END loadBrands

    loadCategories() {
      const vm = this;
      this.conectToDB({
        file: 'Products',
        action: 'getCategory',
        params: { isActive: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.AllCategories = vm.renameToLabel(res.data.data);
          vm.AllCategories.unshift({ id: -1, label: '* Crear nueva categoría *'});
        },
      });
    }, // loadCategories

    loadPhoto(format, event) {
      this.response = event;
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (!input.files || !input.files[0]) return;
      // Check file extension
      let fileName = input.files[0].name;
      let ext3 = fileName.substring(fileName.length-3, fileName.length);
      let ext4 = fileName.substring(fileName.length-4, fileName.length);
      if (ext3 != format && ext4 != format) {
        this.myNotify('danger', '¡Error!', `Solo se permiten el formato .${format}`);
        return;
      }
      // create a new FileReader to read this image and convert to base64 format
      var reader = new FileReader();
      // Define a callback function to run, when FileReader finishes its job
      reader.onload = (e) => {
        // Note: arrow function used here, so that "this.photoData" refers to the photoData of Vue component
        // Read image as base64 and set to photoData
        switch (format) {
          case 'webp':
            this.photoDataWEBP = e.target.result;
            break;
          case 'jpg':
            this.photoDataJPG = e.target.result;
            break;
        }
      }
      // Start the reader job - read file as a data url (base64 format)
      reader.readAsDataURL(input.files[0]);

      // Send it by ajax -
      var formData = new FormData();
      formData.append("file", input.files[0]);

      // // Show info
      // for (var pair of formData.entries()) {
      //   console.log(pair[0]);
      //   console.log(pair[1]);
      //   console.log('---------');
      // }

      switch (format) {
        case 'webp':
          var destinyURL = 'images/catalogue/';
          break;
        case 'jpg':
          var destinyURL = 'images/catalogue/jpg/';
          break;
        default: return;
      }

      formData.append('fileName', this.NewProduct.id +'-1');
      formData.append('destinyURL', destinyURL);
      formData.append('action', 'newUpload');
      this.conectToDB({
        file: 'Uploads', action: 'newUpload', params: formData,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log(res.data);
        },
      });
    }, // loadPhoto

    loadProductCategories(detailsID) {
      const vm = this;
      this.conectToDB({
        file: 'Products', action: 'getProductDetailsCategory',
        params: { detailsID: detailsID, isActive: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.LoadedCategories = vm.renameToLabel(res.data.data);
          vm.SelectedCategories = vm.renameToLabel(res.data.data);
        },
      });
    }, // loadProductCategories

    loadProductDetails(detailsID) {
      const vm = this;
      this.conectToDB({
        file: 'Products', action: 'getProductDetails',
        params: { detailsID: detailsID },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          let AllDetails = res.data.data[0];
          for (let prop in AllDetails) {
            if (typeof vm.NewProduct[prop] == 'undefined') continue;
            vm.NewProduct[prop] = AllDetails[prop];
          }
          // brand
          for (let i in vm.AllBrands) {
            if (vm.AllBrands[i].id == AllDetails.brandID) {
              vm.SelectedBrand = vm.AllBrands[i];
            }
          }
          vm.LoadedPrice = AllDetails.price;
          vm.LoadedOffert = AllDetails.offert;
          vm.loadProductCategories(detailsID);
        },
      });
    }, // loadProductDetails

    loadProductSupplier(productID) {
      const vm = this;
      this.conectToDB({
        file: 'Products', action: 'getProductSuppliers',
        params: { productID: productID, isActive: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.LoadedSuppliers = vm.renameToLabel(res.data.data);
          vm.SelectedSuppliers = vm.renameToLabel(res.data.data);
        },
      });
    }, // loadProductSupplier

    loadSuppliers() {
      const vm = this;
      this.conectToDB({
        file: 'Suppliers', action: 'getSupplier', params: { isActive: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.AllSuppliers = vm.renameToLabel(res.data.data);
          vm.AllSuppliers.unshift({ id: -1, label: '* Crear nuevo proveedor *'});
        },
      });
    }, // loadSuppliers

    modifyProduct() {
      console.log('modifico');
    }, // modifyProduct

    modifySupplierUProduct(params) {
      this.conectToDB({
        file: 'NewProduct', action: 'modifySupplierUProduct',
        params: params,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log('Producto modificado en el proveedor');
        },
      });
    }, // modifySupplierUProduct

    startEditProduct(Product) {
      this.editingProduct = true;
      // Product
      this.NewProduct.productID = Product.id;
      for (let key in this.NewProduct) {
        if (typeof Product[key] != 'undefined') {
          this.NewProduct[key] = Product[key];
        }
      }
      // Brand
      for (var i in this.AllBrands) {
        if (this.AllBrands[i].id == Product.brandID) {
          this.SelectedBrand = this.AllBrands[i];
        }
      }
      // Categories
      this.loadProductCategories(Product.detailsID);
      // Suppliers
      this.loadProductSupplier(Product.id);
      // img
      this.photoDataWEBP = this.getImg(`images/catalogue/${Product.id}-1.webp`);
      this.photoDataJPG = this.getImg(`images/catalogue/jpg/${Product.id}-1.jpg`);
    }, // startEditProduct

    startNewProduct(detailsID = 0) {
      this.NewProduct.detailsID = detailsID;
      if (detailsID == 0) {
        this.cleanData();
        return;
      }
      const vm = this;
      this.loadProductDetails(detailsID);
      // loadSiblings
      this.conectToDB({
        file: 'Products',
        action: 'getProduct',
        params: { productDetailsID: detailsID, isActive: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.Siblings = res.data.data;
        },
      });
    }, // startNewProduct

    updateCategories() {
      const vm = this;
      // Add new categories
      for (let i in vm.SelectedCategories) {
        let params = {
          detailsID: vm.NewProduct.detailsID,
          categoryID: vm.SelectedCategories[i].id,
        }
        let isNew = true;
        for (let j in vm.LoadedCategories) {
          if (vm.LoadedCategories[j] == null) continue
          if (vm.LoadedCategories[j].id ==  vm.SelectedCategories[i].id) {
            vm.LoadedCategories[j] = null;
            isNew = false;
          }
        }
        if (isNew) {
          vm.addProductDetailsUCategories(params);
        }
      }
      // Remove extra categories
      for (let i in vm.LoadedCategories) {
        if (vm.LoadedCategories[i] == null) continue
        let params = {
          detailsID: vm.NewProduct.detailsID,
          categoryID: vm.LoadedCategories[i].id,
          isActive: 0,
        }
        vm.deleteProductDetailsUCategories(params);
      }
      vm.LoadedCategories = [];
    }, // updateCategories

    updatePrice() {
      const vm = this;
      if (vm.NewProduct.price != vm.LoadedPrice || vm.NewProduct.offert != vm.LoadedOffert) {
        let params = {
          detailsID: vm.NewProduct.detailsID,
          price: vm.NewProduct.price,
          offert: vm.NewProduct.offert,
        }
        vm.addProductPriceHistory(params);
      }
    }, // updatePrice

    updateSuppliers() {
      const vm = this;
      // Add new suppliers
      for (let i in vm.SelectedSuppliers) {
        if (vm.SelectedSuppliers[i] == null) continue;
        for (let j in vm.LoadedSuppliers) {
          var isNew = true;
          var isNewPrice = true;
          if (vm.SelectedSuppliers[i].id == vm.LoadedSuppliers[j].id) {
            vm.LoadedSuppliers[j] = null;
            isNew = false;
            if (vm.SelectedSuppliersPrices[i] == vm.LoadedSuppliers[j].price) {
              isNewPrice = false;
            }
          }
        }
        let params = {
          supplierID: vm.SelectedSuppliers[i].id,
          productID: vm.NewProduct.id,
          price: vm.SelectedSuppliersPrices[i],
        }
        if (isNew) {
          vm.addSupplierUProduct(params);
        } else if (isNewPrice) {
          vm.modifySupplierUProduct(params);
        }
      }
      // Remove extra suppliers
      for (let i in vm.LoadedSuppliers) {
        if (vm.LoadedSuppliers[i] == null) continue;
        let params = {
          supplierID: vm.LoadedSuppliers[i].id,
          productID: vm.NewProduct.id,
          isActive: 0,
        }
        vm.modifySupplierUProduct(params);
      }
      vm.LoadedSuppliers = [];
    }, // updateSuppliers



  }, // METHODS
} // EXPORT
</script>










<!-- - - - - - - - - - - - - - - - STYLE - - - - - - - - - - - - - - - -->
<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 600px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }

  // Custom
  // Hide number arrows
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type=number] {
    -moz-appearance:textfield; /* Firefox */
  }
  .noPaddingX {
    padding-left:  0;
    padding-right: 0;
  }
  .noMarginX {
    margin-left:  0;
    margin-right: 0;
  }
  .labelTitle {
    padding-left: 5px;
    font-size: .85rem;
    color: rgba(0,0,0,.7);
    display: block;
  }
  .textarea {
    // border: 1px solid rgba(0, 0, 0, 0.2);
    border: 5px solid red;
  }
  .input {
    height: 37px;
    border-radius: 5px;
  }
  .colLeft {
    padding-left:  0px;
    padding-right: 5px;
  }
  .colRight {
    padding-left: 5px;
    padding-right:  0px;
  }
  .colCenter {
    padding-right: 5px;
    padding-left:  5px;
  }
  .numberInputList {
    margin-top: 9px;
    padding: 10px 0;
  }
  .numberInputList:first-of-type {
    margin-top: 5px;
    margin-bottom: 0px;
  }
  .numberInputRight {
    margin-right: 0;
    margin-left:  5px;
  }
  .numberInputLeft {
    margin-left:  0;
    margin-right: 5px;
  }
  .priceMultiplier {
    width: 100%;
    margin-top: 5px;
    line-height: 43px;
    border-radius: 5px;
    border: 0;
    padding-left: 27px;
    margin-left: 5px;
    background-color: rgb(245, 245, 245);
  }
  .priceMultiplierX {
    position: absolute;
    top: 16px;
    left: 22px;
  }
  .helpInfo {
    text-align: center;
    width: 100%;
    margin-top: 30px;
    opacity: 0.5;
  }
  .allImgContainer {
    width: 100%;
    position: relative;
    margin-top: 5px;
  }
  .loadImgBTN {
    // Para que esté default se puede usar la clase con-input-upload
    background-color: #F5F5F5;
    border-radius: 5px;
    height: 200px;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    border: 1px dashed rgba(0,0,0,.1);
    font-weight: 600;
    cursor: pointer;
  }
  .loadImgBTN:hover {
    border-color: rgba(21, 176, 206, .5); /* 50% of #15B0CE */
  }
  .loadImgBTN:focus {
    // border-color: #15B0CE;
  }
  .deleteImgBTN {
    background-color: rgba(0, 0, 0, .25);
    height: 35px;
    width: 35px;
    padding: 8px;
    border-radius: 5px;
    box-shadow: 0 0 15px 0 rgba(0,0,0,.1);
    color: white;
    position: absolute !important;
    top: 0px;
    right: 0px;
    cursor: pointer;
  }
  .imgPreview {
    width: 100%;
    height: 250px;
  }
  .imgPreview img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 5px;
    display: block;
    margin-right: auto;
    margin-left: auto;
  }
  .sidebarHeaderItemSeparation {
    margin-left: 15px;
    padding-left: 16px;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    height: 22px;
  }
  .sidebarHeaderItem {
    margin-left: 0;
  }
  .sidebarHeaderItem,
  .sidebarTitle {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 10px;
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}
</style>
